import React, { useState, createContext, useContext } from 'react';
type SidebarMode = 'hover' | 'expanded' | 'collapsed';
interface SidebarContextType {
  mode: SidebarMode;
  setMode: (mode: SidebarMode) => void;
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
}
const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
export function SidebarProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [mode, setMode] = useState<SidebarMode>('hover');
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <SidebarContext.Provider value={{
    mode,
    setMode,
    isExpanded,
    setIsExpanded,
    isMobileMenuOpen,
    setIsMobileMenuOpen
  }} data-id="element-271">
      {children}
    </SidebarContext.Provider>;
}
export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
}